import {useCallback, useEffect, useRef, useState} from 'react';

export const PREVENT_OUTSIDE_CLICK_ATTR = 'data-prevent-outside-click';

// @typescript-eslint/ban-types
export default function useComponentVisible(initialIsVisible: boolean, parents?: string, callback?: () => void) {
    const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
    const ref = useRef<HTMLDivElement>(null);

    const compareChildren = (ev: MouseEvent) => {
        // @ts-expect-error may provide problems
        // @typescript-eslint/ban-types
        return ref.current && !ref.current.contains(ev.target);
    }

    const compareParents = useCallback(() => {
        // @ts-expect-error may provide problems
        // @typescript-eslint/ban-types
        return ref.current && !ref.current.contains(document.getElementById(parents));
    }, [ref, parents]);

    useEffect(() => {
        const handleClickOutside = (ev: MouseEvent) => {
            if (ev.target instanceof Element && ev.target.closest(`[${PREVENT_OUTSIDE_CLICK_ATTR}]`)) {
                return;
            }
            const compare = !parents ? compareChildren(ev): compareParents();
            if (compare) {
                setIsComponentVisible(false);
                if (callback) {
                    callback();
                }
            }
        }

        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [callback, compareParents, parents]);

    return {ref, isComponentVisible, setIsComponentVisible};
}
